import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import '@/assets/less/common.less'
import pinia from "@/store";

createApp(App).use(pinia).use(router).mount('#app')
